import React, {PureComponent} from "react"
import id from "@irati/utils/id"
import PerksGOScheduledTransfer from "./PerksGO"

interface Props {
  className?: string|null,
  scheduledTransfer: ScheduledTransfer,
  id?: string
}

class ScheduledTransferClass extends PureComponent<Props> {
  static defaultProps = {
    className: null
  }

  render() {
    const {className, scheduledTransfer} = this.props
    const idNamespace = id("scheduled-transfer", this.props)
    if (scheduledTransfer.perksGO) {
      return <PerksGOScheduledTransfer id={idNamespace} className={className} scheduledTransfer={scheduledTransfer} />
    }
    return null
  }
}

export default ScheduledTransferClass
